export default __webpack_public_path__ + "static/lozenge-do-4-dark-8bd602becd280712f5d92c6eb949d194.png";